import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import StatewideResults from './StatewideResults'
import { API_ENDPOINT } from '../../config'
import ElectionContext from '../../context/ElectionContext'

const Statewide = () => {
  const context = useContext(ElectionContext)
  return (
    <div className="Legislature">
      <Helmet>
        <title>MPR News | Live Results for Statewide Races</title>
        <meta
          name="twitter:title"
          content="LIVE Election Results from MPR News | Statewide Races"
        />
        <meta
          property="og:title"
          content="LIVE Election Results from MPR News | Statewide Races"
        />
      </Helmet>
      <StatewideResults
        interval={30000}
        url={`${API_ENDPOINT}/${context.date}/statewide_races`}
      />
    </div>
  )
}

export default Statewide
